import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import UserForm from '../../../components/UserForm/UserForm';
import * as actions from '../../../store/users/actions';

function EditUser() {
  const connectedUser = useSelector((state) => state.auth?.user?.data);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { user } = useSelector(state => state.users);

  useEffect(() => {
    if (id) {
      dispatch(actions.userRequest(id));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  if (connectedUser?.role_id !== 1) {
    return "Your are not authorized to view this page";
  }

  return (
    <div>
        <UserForm user={user} />
    </div>
  );
}

export default EditUser;
